import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataCoreService, DlistFieldDto,
  environment as env, GetDlist_Request, GetDlist_Response } from '@dabnet-kamu/libs/ui';
import { BehaviorSubject, catchError, finalize, tap, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PdfViewOtherUstVeriService {

  private _genGrupFieldsList: BehaviorSubject<DlistFieldDto[] | null> = new BehaviorSubject(null);
  public genGrupFieldsList$ = this._genGrupFieldsList.asObservable();

  errorResponse: string[]

  constructor(private dataCoreService: DataCoreService, private _httpClient: HttpClient) { }
  
  getDlist(formName: string) {
    const request=new GetDlist_Request({
      dListCode:formName
    })
    this._httpClient.post<GetDlist_Response>(`${env.ortakService}/System/GetDList`, request).pipe(
      tap(response => {
          this._genGrupFieldsList.next(response.dListMetadata.fields);


      }),
      catchError(err => throwError(err)),
      finalize(() => {})
    ).subscribe();
  }


  getBysBelge(Kod:number){
    const dataSource=this.dataCoreService.getOData('BysBelge');
    dataSource.select([]);
    const filterArr = [];
    filterArr.push(['Kod', '=',Kod]);
   dataSource.filter(filterArr);
    return  dataSource.load()
  }

  getBysBelgeDetay(Kod:number){
    const dataSource=this.dataCoreService.getOData('BysBelgeDetay');
    dataSource.select([]);
    const filterArr = [];
    filterArr.push(['BelgeKod', '=',Kod]);
   dataSource.filter(filterArr);
    return  dataSource.load()
  }

  
  getBelgeTuru(dosyaPlanKod:string){
    const dataSource=this.dataCoreService.getOData('GenBelgeTuru');
    dataSource.select([]);
    const filterArr = [];
    filterArr.push(['DosyaPlanKod', '=',dosyaPlanKod]);
   dataSource.filter(filterArr);
    return  dataSource.load()
  }

  updateBysBelgeDataStore(data: any) {
    return this.dataCoreService.updateDataStore('BysBelge', data);
  }

  createBysBelgeDataStore(data:any){
    return this.dataCoreService.createDataStore('BysBelge',data);
  }
}
